import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";

interface GuestErrorScreenProps {
  open: boolean;
  onBackToMenu: () => void;
}

export const GuestErrorScreen = ({ open, onBackToMenu }: GuestErrorScreenProps) => (
  <Dialog open={open} maxWidth="sm" fullWidth>
    <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", textAlign: "center", py: 4 }}>
      <Typography variant="h3">Something went wrong</Typography>
      <Typography>We couldn&apos;t place your order. Please try again or ask a staff member for assistance.</Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
      <Button variant="contained" onClick={onBackToMenu}>
        Back to Menu
      </Button>
    </DialogActions>
  </Dialog>
);
